import { createReducer } from '@reduxjs/toolkit'

import { dspLineItemsTableColumnsConfig } from 'configuration/tables/dspCampaignFactsTable'
import { DATES } from 'const/filters'
import { FILTER_SETTINGS, LOCAL_FILTERS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [LOCAL_FILTERS]: {},
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [],
        displayState: {},
    },
    table: getDefaultTable(serializeColumns(dspLineItemsTableColumnsConfig), {
        sorter: {
            field: 'total_cost__sum',
            order: 'descend',
        },
    }),
}

export default createReducer(initialState, () => {})
